/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-06-07 10:30:50
 *
 *******************************************************/
//@flow
import _ from 'lodash';
import React, { Component } from 'react';
import { InlineError, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import Select from 'react-select';
import { RenderLabelTooltip } from './render-label-tooltip';
import { selectStyle } from './render-select.style';

type Props = WithI18nProps;

class RenderSelect3Component extends Component<Props> {
  state = {
    cacheUniqs: [1],
    emptyValue: false
  };

  componentWillReceiveProps(nextProps) {
    const { options = [] } = nextProps;
    const { options: optionsPrev = [] } = this.props;

    // Force render component if the options change
    if (_.get(options, '[0].value') !== _.get(optionsPrev, '[0].value')) {
      this.setState({ cacheUniqs: [this.state.cacheUniqs[0] + 1] });
    }

    const preOptionName = optionsPrev.map(option => `${option.name}-${option.updated_at}`).join('');
    const newOptionName = options.map(option => `${option.name}-${option.updated_at}`).join('');
    if (preOptionName !== newOptionName) {
      this.setState({ cacheUniqs: [this.state.cacheUniqs[0] + 1] });
    }
  }
  render() {
    const {
      meta,
      options,
      label,
      tooltip,
      input,
      isDisabled,
      textHelper,
      placeholderEmpty,
      maxMenuHeight = 150,
      i18n,
      loading,
      components = {},
      styles = {},
      menuPosition = 'absolute',
      isSearchable = true,
      classNamePrefix = 'BC-Select',
      formatOptionLabel
    } = this.props;

    const { emptyValue } = this.state;
    const hasError = !!meta.error && !!meta.touched && !loading;

    let { placeholder } = this.props;
    placeholder =
      _.isEmpty(options) && !loading
        ? placeholderEmpty || i18n.translate('AdminHTML.Common.Empty.select_Placeholder')
        : placeholder;
    return (
      <div className={hasError ? 'Polaris-TextField--error' : 'Polaris-Select-2'}>
        <RenderLabelTooltip label={label} tooltip={tooltip} />
        <Select
          id={input.name}
          options={options}
          value={input.value}
          onChange={value => {
            input.onChange(value);
          }}
          onBlur={() => {
            if (!input.value || _.isEmpty(input.value)) {
              this.setState({ emptyValue: true });
            } else {
              this.setState({ emptyValue: false });
            }
          }}
          label={label}
          styles={{ ...selectStyle, ...styles }}
          placeholder={placeholder}
          maxMenuHeight={maxMenuHeight}
          menuPortalTarget={document.body}
          classNamePrefix={classNamePrefix}
          isDisabled={isDisabled ? true : false}
          cacheUniqs={this.state.cacheUniqs}
          noOptionsMessage={() => i18n.translate('AdminHTML.Common.Empty.reactSelect_NoOptions')}
          isOptionDisabled={option => option.disabled || option.isDisabled}
          components={components}
          menuPosition={menuPosition}
          isSearchable={isSearchable}
          formatOptionLabel={formatOptionLabel}
        />

        {textHelper ? (
          <p style={{ marginTop: '0.25rem' }}>
            <TextStyle variation="subdued">{textHelper}</TextStyle>
          </p>
        ) : (
          ''
        )}
        {meta.error && emptyValue ? <InlineError message={meta.error} /> : ''}
      </div>
    );
  }
}

export const RenderSelect3 = withI18n()(RenderSelect3Component);
